import { State, Action, StateContext, Selector } from '@ngxs/store';
import { ShowLoader, HideLoader } from './loader.actions';
import { ILoaderStateModel } from '../../models/loader.model';

@State<ILoaderStateModel>({
  name: 'loader',
  defaults: {
    loading: false
  }
})
export class LoaderState {
  @Selector()
  static isLoading(state: ILoaderStateModel): boolean {
    return state.loading;
  }

  @Action(ShowLoader)
  showLoader(ctx: StateContext<ILoaderStateModel>) {
    ctx.patchState({ loading: true });
  }

  @Action(HideLoader)
  hideLoader(ctx: StateContext<ILoaderStateModel>) {
    ctx.patchState({ loading: false });
  }
}